/**
 * Single source of truth for the site's identity — page metadata, social
 * previews and structured data all read from here (see src/SEO.tsx).
 *
 * The description reflects what the platform actually offers: courses with
 * lessons, quizzes and certificates, scholarships, and events. It deliberately
 * does not repeat the previous "50K+ scholars worldwide" claim, which appeared
 * nowhere in the data.
 */
const siteMetadata = {
  title: 'Mindalitix Academy — Online courses, scholarships and certification',
  author: 'Mindalitix Team',
  headerTitle: 'Mindalitix Academy',
  description:
    'Mindalitix Academy offers online courses with lessons, quizzes and certificates, plus scholarship opportunities and events for students and professionals.',
  language: 'en-us',
  theme: 'system',
  /**
   * The canonical origin, from VITE_SITE_URL. Everything that emits an absolute
   * URL — canonical tags, Open Graph, structured data, the sitemap and the
   * prerendered course pages — reads it from here, so the site moves domain by
   * changing one environment variable.
   */
  siteUrl: (import.meta.env.VITE_SITE_URL || 'https://mindalitixacademy.com').replace(/\/$/, ''),
  siteRepo: 'https://github.com/Mindalitix/mindalitix',
  siteLogo: '/icon512_rounded.png',
  image: '/icon512_rounded.png',
  socialBanner: '/icon512_rounded.png',
  email: 'mindalitix@gmail.com',
  github: 'https://github.com/Mindalitix/mindalitix',
  twitter: 'https://x.com/mindalitix',
  facebook: 'https://www.facebook.com/share/1C6AvJBA9r/',
  instagram: 'https://www.instagram.com/mindalitix',
  youtube: '',
  linkedin: 'https://www.linkedin.com/company/mindalitix-academy/',
  locale: 'en-US',
  newsletter: {
    provider: '',
  },
  comment: {
    provider: '',
    giscusConfig: {},
  },
};
export default siteMetadata;
